var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting_modal" }, [
    _c("div", { staticClass: "setting_customize" }, [
      _c("div", { staticClass: "setting_customize_header" }, [
        _c("p", { staticClass: "setting_customize_header_title" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.labelProperties.PREVIEW_TITLE) +
              "\n      "
          )
        ]),
        _c(
          "div",
          {
            staticClass: "setting_customize_header_close",
            on: {
              click: function($event) {
                _vm.$emit("close")
                _vm.step = 1
              }
            }
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  width: "12",
                  height: "12",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("g", { attrs: { fill: "#AAA", "fill-rule": "evenodd" } }, [
                  _c("path", {
                    attrs: { d: "M.255 1.545l.99-.99 9.9 9.9-.99.99z" }
                  }),
                  _c("path", {
                    attrs: { d: "M10.155.555l.99.99-9.9 9.9-.99-.99z" }
                  })
                ])
              ]
            )
          ]
        )
      ]),
      _c("div", { staticClass: "setting_customize_body" }, [
        _c(
          "div",
          {
            staticClass: "setting_customize_preview",
            style: { backgroundColor: _vm.colors.pageBackground }
          },
          [
            _c(
              "div",
              {
                staticClass: "jobs_wrapper",
                attrs: { id: "top_modal_preview" }
              },
              [
                _vm.step === 1
                  ? [
                      _vm.jobPageName
                        ? _c(
                            "h1",
                            {
                              staticClass:
                                "jobs_page_title_preview setting_word_break",
                              style: { color: _vm.colors.pageText }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.jobPageName) +
                                  "\n            "
                              )
                            ]
                          )
                        : _c(
                            "h1",
                            {
                              staticClass: "jobs_page_title",
                              style: { color: _vm.colors.pageText }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.labelProperties.JOB_PAGE_TITLE) +
                                  "\n            "
                              )
                            ]
                          ),
                      _vm.jobOverview
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "jobs_table_annotation_preview setting_word_break"
                            },
                            [_vm._v(_vm._s(_vm.jobOverview))]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "jobs_table_wrapper" },
                        [
                          _vm._l(_vm.categoriesSearchJob, function(
                            category,
                            indexOfCategory
                          ) {
                            return [
                              category &&
                              !category.categoryDeleted &&
                              !_vm.isEmptyCategoryInJobSearch(indexOfCategory)
                                ? [
                                    _c(
                                      "h2",
                                      {
                                        key: indexOfCategory,
                                        staticClass: "jobs_category_title mt-3",
                                        style: {
                                          color: _vm.colors.pageText,
                                          borderLeftColor: _vm.colors.keyColor
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(category.categoryName) +
                                            "\n                  "
                                        )
                                      ]
                                    ),
                                    _vm._l(category.item, function(
                                      item,
                                      index
                                    ) {
                                      return _c(
                                        "table",
                                        {
                                          key:
                                            "c_" +
                                            indexOfCategory +
                                            "i_" +
                                            index,
                                          staticClass: "jobs_table",
                                          style: {
                                            backgroundColor:
                                              _vm.colors.pageBackground
                                          }
                                        },
                                        [
                                          !item.itemDeleted &&
                                          !item.resourceField[0]
                                            .isItemDeletedByMainSystem
                                            ? _c(
                                                "tbody",
                                                {
                                                  staticClass: "jobs_table_body"
                                                },
                                                [
                                                  _c(
                                                    "tr",
                                                    {
                                                      staticClass:
                                                        "jobs_table_rows"
                                                    },
                                                    [
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "jobs_table_head",
                                                          style: [
                                                            {
                                                              backgroundColor:
                                                                _vm.colors
                                                                  .subColor
                                                            },
                                                            index === 0
                                                              ? {
                                                                  border:
                                                                    "1px solid" +
                                                                    _vm.colors
                                                                      .borderColor
                                                                }
                                                              : {
                                                                  borderLeft:
                                                                    "1px solid" +
                                                                    _vm.colors
                                                                      .borderColor,
                                                                  borderRight:
                                                                    "1px solid" +
                                                                    _vm.colors
                                                                      .borderColor,
                                                                  borderBottom:
                                                                    "1px solid" +
                                                                    _vm.colors
                                                                      .borderColor
                                                                }
                                                          ]
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "jobs_table_head_holder"
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "jobs_table_label",
                                                                  style: {
                                                                    color:
                                                                      _vm.colors
                                                                        .pageText
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                              " +
                                                                      _vm._s(
                                                                        item.itemName
                                                                      ) +
                                                                      "\n                            "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "jobs_table_cell",
                                                          style: [
                                                            index === 0
                                                              ? {
                                                                  border:
                                                                    "1px solid" +
                                                                    _vm.colors
                                                                      .borderColor
                                                                }
                                                              : {
                                                                  borderLeft:
                                                                    "1px solid" +
                                                                    _vm.colors
                                                                      .borderColor,
                                                                  borderRight:
                                                                    "1px solid" +
                                                                    _vm.colors
                                                                      .borderColor,
                                                                  borderBottom:
                                                                    "1px solid" +
                                                                    _vm.colors
                                                                      .borderColor
                                                                }
                                                          ]
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "jobs_table_form_rows"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "jobs_table_form_item"
                                                                },
                                                                [
                                                                  _c(
                                                                    "InputComponent",
                                                                    {
                                                                      staticClass:
                                                                        "mt-3",
                                                                      attrs: {
                                                                        resource:
                                                                          item
                                                                            .resourceField[0],
                                                                        master: _vm.getMasterData(
                                                                          item
                                                                            .resourceField[0]
                                                                            .master_name
                                                                        ),
                                                                        itemJob: true,
                                                                        itemName:
                                                                          item.itemName,
                                                                        draftColors:
                                                                          _vm.colors
                                                                      }
                                                                    }
                                                                  ),
                                                                  item.viewAnnotation &&
                                                                  item.annotationText
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "jobs_table_annotation setting_word_break",
                                                                              style: {
                                                                                color:
                                                                                  _vm
                                                                                    .colors
                                                                                    .pageText
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                  ※" +
                                                                                  _vm._s(
                                                                                    item.annotationText
                                                                                  ) +
                                                                                  "\n                                "
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    })
                                  ]
                                : _vm._e()
                            ]
                          }),
                          _c(
                            "h2",
                            {
                              staticClass: "jobs_category_title mt-3",
                              style: {
                                color: _vm.colors.pageText,
                                borderLeftColor: _vm.colors.keyColor
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.labelProperties.CATEGORY_FREE_WORD
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _c("table", { staticClass: "jobs_table" }, [
                            _c("tbody", { staticClass: "jobs_table_body" }, [
                              _c("tr", { staticClass: "jobs_table_rows" }, [
                                _c(
                                  "th",
                                  {
                                    staticClass: "jobs_table_head",
                                    style: {
                                      backgroundColor: _vm.colors.subColor,
                                      borderLeft:
                                        "1px solid" + _vm.colors.borderColor,
                                      borderBottom:
                                        "1px solid" + _vm.colors.borderColor
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "jobs_table_head_holder" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "jobs_table_label",
                                            style: {
                                              color: _vm.colors.pageText
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.labelProperties
                                                  .FREE_WORD_SEARCH
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "td",
                                  {
                                    staticClass: "jobs_table_cell",
                                    style: {
                                      borderLeft:
                                        "1px solid" + _vm.colors.borderColor,
                                      borderRight:
                                        "1px solid" + _vm.colors.borderColor,
                                      borderBottom:
                                        "1px solid" + _vm.colors.borderColor
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "jobs_table_form_rows" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "jobs_table_form_item mt-3"
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.freeWord,
                                                  expression: "freeWord"
                                                }
                                              ],
                                              staticClass: "jobs_form_text",
                                              attrs: {
                                                type: "text",
                                                placeholder:
                                                  _vm.labelProperties
                                                    .PLACE_HOLDER_WORD_SEARCH
                                              },
                                              domProps: { value: _vm.freeWord },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.freeWord =
                                                    $event.target.value
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "jobs_table_form_rows" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "jobs_table_form_item"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "jobs_table_form_label_box"
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "setting_form_radio_label"
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: _vm.condition,
                                                          expression:
                                                            "condition"
                                                        }
                                                      ],
                                                      attrs: {
                                                        type: "radio",
                                                        id: "and",
                                                        value: "and"
                                                      },
                                                      domProps: {
                                                        checked: _vm._q(
                                                          _vm.condition,
                                                          "and"
                                                        )
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          _vm.condition = "and"
                                                        }
                                                      }
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "setting_form_radio_text",
                                                        style: {
                                                          color:
                                                            _vm.colors.pageText
                                                        },
                                                        attrs: { for: "and" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.labelProperties
                                                              .AND
                                                          ) +
                                                            "\n                              "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "setting_form_radio_label"
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: _vm.condition,
                                                          expression:
                                                            "condition"
                                                        }
                                                      ],
                                                      attrs: {
                                                        type: "radio",
                                                        id: "or",
                                                        value: "or"
                                                      },
                                                      domProps: {
                                                        checked: _vm._q(
                                                          _vm.condition,
                                                          "or"
                                                        )
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          _vm.condition = "or"
                                                        }
                                                      }
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "setting_form_radio_text",
                                                        style: {
                                                          color:
                                                            _vm.colors.pageText
                                                        },
                                                        attrs: { for: "or" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.labelProperties
                                                              .OR
                                                          ) +
                                                            "\n                              "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "ml-3 jobs_table_annotation",
                                                    style: {
                                                      color: _vm.colors.pageText
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.labelProperties
                                                          .NOTICE_FREE_WORD
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "jobs_annotation_box" }, [
                            _c("p", { staticClass: "jobs_annotation_text" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.labelProperties
                                      .NOTICE_CANT_SEARCH_COMBINATION
                                  ) +
                                  "\n                "
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "jobs_btn_box" }, [
                            _c(
                              "button",
                              {
                                staticClass: "jobs_btn_primary mt-5",
                                style: {
                                  color: _vm.colors.mainButtonText,
                                  backgroundColor: _vm.colors.mainButton,
                                  border: "1px solid" + _vm.colors.borderColor
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.searchJob()
                                  }
                                }
                              },
                              [
                                !_vm.button.searchBtn
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.labelProperties.CONFIRM_BUTTON
                                          ) +
                                          "\n                  "
                                      )
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.button.searchBtn) +
                                          "\n                  "
                                      )
                                    ])
                              ]
                            )
                          ])
                        ],
                        2
                      )
                    ]
                  : _vm._e(),
                _vm.step === 2
                  ? [
                      _c("h1", { staticClass: "jobs_page_title" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.searchJobLabelsProperty.SEARCH_RESULT_LIST
                            ) +
                            "\n            "
                        )
                      ]),
                      _c("h2", { staticClass: "jobs_category_title" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.searchJobLabelsProperty
                                .CURRENT_SEARCH_CRITERIA
                            ) +
                            "\n            "
                        )
                      ]),
                      _c("div", { staticClass: "jobs_search_condition" }, [
                        _c(
                          "div",
                          { staticClass: "jobs_search_condition_inner" },
                          [
                            !_vm.freeWord
                              ? [
                                  _vm._l(_vm.categoriesSearchJob, function(
                                    category,
                                    indexOfCategory
                                  ) {
                                    return [
                                      _c(
                                        "dl",
                                        {
                                          key: "c" + indexOfCategory,
                                          staticClass:
                                            "jobs_search_condition_list"
                                        },
                                        [
                                          _vm._l(category.item, function(
                                            item,
                                            indexOfItem
                                          ) {
                                            return [
                                              !item.resourceField[0]
                                                .isDeletedByMainSystem &&
                                              item.resourceField[0].isHasValue
                                                ? [
                                                    _c(
                                                      "dt",
                                                      {
                                                        key:
                                                          "c" +
                                                          indexOfCategory +
                                                          "i" +
                                                          indexOfItem,
                                                        staticClass:
                                                          "jobs_search_condition_label setting_word_break"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                            " +
                                                            _vm._s(
                                                              item.itemName
                                                            ) +
                                                            "\n                          "
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "dd",
                                                      {
                                                        key:
                                                          "ci" +
                                                          indexOfCategory +
                                                          indexOfItem,
                                                        staticClass:
                                                          "jobs_search_condition_desc setting_word_break"
                                                      },
                                                      [
                                                        (item.resourceField[0]
                                                          .default_value &&
                                                          (item.resourceField[0]
                                                            .type === "text" ||
                                                            item
                                                              .resourceField[0]
                                                              .type ===
                                                              "textarea" ||
                                                            item
                                                              .resourceField[0]
                                                              .type === "url" ||
                                                            item.resourceField[0].type.includes(
                                                              "email"
                                                            ))) ||
                                                        item.resourceField[0]
                                                          .type === "tel" ||
                                                        item.resourceField[0]
                                                          .type === "sequence"
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                              " +
                                                                  _vm._s(
                                                                    item
                                                                      .resourceField[0]
                                                                      .default_value
                                                                  ) +
                                                                  "\n                            "
                                                              )
                                                            ])
                                                          : item
                                                              .resourceField[0]
                                                              .default_value &&
                                                            (item
                                                              .resourceField[0]
                                                              .type ===
                                                              "multi_select" ||
                                                              item
                                                                .resourceField[0]
                                                                .type ===
                                                                "checkbox") &&
                                                            item
                                                              .resourceField[0]
                                                              .default_value
                                                              .length > 0
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                              " +
                                                                  _vm._s(
                                                                    _vm.getValueCheckBox(
                                                                      item
                                                                        .resourceField[0]
                                                                        .default_value
                                                                    )
                                                                  ) +
                                                                  "\n                            "
                                                              )
                                                            ])
                                                          : item
                                                              .resourceField[0]
                                                              .default_value !==
                                                              null &&
                                                            (item
                                                              .resourceField[0]
                                                              .type ===
                                                              "single_select" ||
                                                              item
                                                                .resourceField[0]
                                                                .type ===
                                                                "select" ||
                                                              item
                                                                .resourceField[0]
                                                                .type ===
                                                                "boolean" ||
                                                              item
                                                                .resourceField[0]
                                                                .type ===
                                                                "radio")
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                              " +
                                                                  _vm._s(
                                                                    _vm.getSingleSelect(
                                                                      item
                                                                        .resourceField[0]
                                                                    )
                                                                  ) +
                                                                  "\n                            "
                                                              )
                                                            ])
                                                          : item
                                                              .resourceField[0]
                                                              .type ===
                                                            "datetime"
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                              " +
                                                                  _vm._s(
                                                                    _vm.getValueDateTime(
                                                                      item
                                                                        .resourceField[0]
                                                                    )
                                                                  ) +
                                                                  "\n                            "
                                                              )
                                                            ])
                                                          : item
                                                              .resourceField[0]
                                                              .type === "date"
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                              " +
                                                                  _vm._s(
                                                                    _vm.getValueDate(
                                                                      item
                                                                        .resourceField[0]
                                                                    )
                                                                  ) +
                                                                  "\n                            "
                                                              )
                                                            ])
                                                          : item
                                                              .resourceField[0]
                                                              .type === "ym"
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                              " +
                                                                  _vm._s(
                                                                    _vm.getValueYearMonth(
                                                                      item
                                                                        .resourceField[0]
                                                                    )
                                                                  ) +
                                                                  "\n                            "
                                                              )
                                                            ])
                                                          : item
                                                              .resourceField[0]
                                                              .type === "time"
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                              " +
                                                                  _vm._s(
                                                                    _vm.getValueTime(
                                                                      item
                                                                        .resourceField[0]
                                                                    )
                                                                  ) +
                                                                  "\n                            "
                                                              )
                                                            ])
                                                          : item
                                                              .resourceField[0]
                                                              .default_value_from ||
                                                            item
                                                              .resourceField[0]
                                                              .default_value_to
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                              " +
                                                                  _vm._s(
                                                                    item
                                                                      .resourceField[0]
                                                                      .default_value_from
                                                                  ) +
                                                                  " ~\n                              " +
                                                                  _vm._s(
                                                                    item
                                                                      .resourceField[0]
                                                                      .default_value_to
                                                                  ) +
                                                                  "\n                            "
                                                              )
                                                            ])
                                                          : _c("span", [
                                                              _vm._v(" -- ")
                                                            ])
                                                      ]
                                                    )
                                                  ]
                                                : _vm._e()
                                            ]
                                          })
                                        ],
                                        2
                                      )
                                    ]
                                  })
                                ]
                              : _vm._e(),
                            _vm.freeWord
                              ? _c(
                                  "div",
                                  { staticClass: "jobs_search_setting" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "jobs_search_condition_label setting_word_break"
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.searchJobLabelsProperty
                                                .FREE_WORD
                                            ) +
                                            "（\n                    "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "text-transform": "uppercase"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(_vm.condition) + " "
                                            )
                                          ]
                                        ),
                                        _vm._v(")\n                  ")
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "jobs_search_condition_desc setting_word_break"
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(_vm.freeWord) +
                                              "\n                    "
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            !_vm.numberOfSearchByItem && !_vm.freeWord
                              ? [
                                  _c("label", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.searchJobLabelsProperty.NONE
                                        ) +
                                        "\n                  "
                                    )
                                  ])
                                ]
                              : _vm._e()
                          ],
                          2
                        ),
                        _c(
                          "div",
                          { staticClass: "jobs_search_condition_btn" },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "jobs_btn_secondary jobs_btn_medium",
                                style: {
                                  color: _vm.colors.subButtonText,
                                  backgroundColor: _vm.colors.subButton
                                },
                                on: {
                                  click: function($event) {
                                    _vm.step = 1
                                    _vm.scrollToTopOfModal()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.searchJobLabelsProperty
                                        .BUTTON_CHANGE_CONDITON_SEARCH
                                    ) +
                                    "\n                "
                                )
                              ]
                            )
                          ]
                        )
                      ]),
                      _vm.numberOfJobDisplay > 0
                        ? _c("div", { staticClass: "jobs_search_result" }, [
                            _c(
                              "span",
                              { staticClass: "jobs_search_result_number" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.numberOfJobDisplay) +
                                    "\n              "
                                )
                              ]
                            ),
                            _c(
                              "span",
                              { staticClass: "jobs_search_result_unit" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.searchJobLabelsProperty.IN_PIECE
                                    ) +
                                    "\n              "
                                )
                              ]
                            ),
                            _c(
                              "span",
                              { staticClass: "jobs_search_result_range" },
                              [
                                _vm._v(
                                  "\n                1 ～ " +
                                    _vm._s(_vm.numberOfJobDisplay) +
                                    " " +
                                    _vm._s(
                                      _vm.searchJobLabelsProperty.SHOW_MATTER
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "jobs_result" },
                        _vm._l(_vm.jobDetails, function(job, indexJobDetail) {
                          return _c(
                            "ul",
                            {
                              key: indexJobDetail,
                              staticClass: "jobs_result_list"
                            },
                            [
                              _c("li", { staticClass: "jobs_result_item" }, [
                                _c(
                                  "div",
                                  { staticClass: "jobs_result_inner" },
                                  [
                                    _c(
                                      "h2",
                                      {
                                        staticClass: "jobs_result_heading",
                                        on: {
                                          click: function($event) {
                                            _vm.step = 3
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: { to: "" },
                                            nativeOn: {
                                              click: function($event) {
                                                return _vm.scrollToTopOfModal()
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "jobs_result_title",
                                                staticStyle: {
                                                  "text-decoration": "none"
                                                },
                                                style: {
                                                  color: _vm.colors.linkText
                                                }
                                              },
                                              [
                                                _vm._l(
                                                  _vm.headingSettings.filter(
                                                    function(headingSetting) {
                                                      return !headingSetting.itemResourceDeleted
                                                    }
                                                  ),
                                                  function(
                                                    headingSetting,
                                                    index
                                                  ) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        { key: "h" + index },
                                                        [
                                                          _vm._v(
                                                            "\n                                " +
                                                              _vm._s(
                                                                headingSetting.display_name
                                                              ) +
                                                              " "
                                                          ),
                                                          index <
                                                          _vm.headingSettings.filter(
                                                            function(
                                                              headingSetting
                                                            ) {
                                                              return !headingSetting.itemResourceDeleted
                                                            }
                                                          ).length -
                                                            1
                                                            ? _c("span", [
                                                                _vm._v("/")
                                                              ])
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._l(
                                      _vm.bodySettings.filter(function(
                                        bodySetting
                                      ) {
                                        return !bodySetting.itemResourceDeleted
                                      }),
                                      function(bodySetting, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "jobs_result_text"
                                          },
                                          [
                                            _c("span", { key: "b" + index }, [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    bodySetting.display_name
                                                  ) +
                                                  "\n                      "
                                              )
                                            ])
                                          ]
                                        )
                                      }
                                    ),
                                    _vm._l(_vm.categoriesJobList, function(
                                      category,
                                      cIndex
                                    ) {
                                      return [
                                        category &&
                                        !category.categoryDeleted &&
                                        !_vm.isEmptyCategory(
                                          _vm.categoriesJobList,
                                          cIndex
                                        )
                                          ? [
                                              _c(
                                                "h2",
                                                {
                                                  key: "cl" + cIndex,
                                                  staticClass:
                                                    "jobs_category_title mt-3",
                                                  style: {
                                                    color: _vm.colors.pageText,
                                                    borderLeftColor:
                                                      _vm.colors.keyColor
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(
                                                        category.categoryName
                                                      ) +
                                                      "\n                        "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "table",
                                                {
                                                  key:
                                                    "cls" +
                                                    cIndex +
                                                    indexJobDetail,
                                                  staticClass:
                                                    "jobs_detail_table"
                                                },
                                                [
                                                  _c(
                                                    "tbody",
                                                    {
                                                      staticClass:
                                                        "jobs_detail_table_body"
                                                    },
                                                    [
                                                      _vm._l(
                                                        category.item,
                                                        function(item, index) {
                                                          return [
                                                            _c(
                                                              "tr",
                                                              {
                                                                key:
                                                                  item
                                                                    .resourceField[0]
                                                                    .name,
                                                                staticClass:
                                                                  "jobs_detail_table_rows"
                                                              },
                                                              [
                                                                _c(
                                                                  "th",
                                                                  {
                                                                    staticClass:
                                                                      "jobs_detail_table_head",
                                                                    style: [
                                                                      {
                                                                        backgroundColor:
                                                                          _vm
                                                                            .colors
                                                                            .subColor
                                                                      },
                                                                      index ===
                                                                      0
                                                                        ? {
                                                                            border:
                                                                              "1px solid" +
                                                                              _vm
                                                                                .colors
                                                                                .borderColor
                                                                          }
                                                                        : {
                                                                            borderLeft:
                                                                              "1px solid" +
                                                                              _vm
                                                                                .colors
                                                                                .borderColor,
                                                                            borderRight:
                                                                              "1px solid" +
                                                                              _vm
                                                                                .colors
                                                                                .borderColor,
                                                                            borderBottom:
                                                                              "1px solid" +
                                                                              _vm
                                                                                .colors
                                                                                .borderColor
                                                                          }
                                                                    ]
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "setting_word_break",
                                                                        style: {
                                                                          color:
                                                                            _vm
                                                                              .colors
                                                                              .pageText
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                    " +
                                                                            _vm._s(
                                                                              item.itemName
                                                                            ) +
                                                                            "\n                                  "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _c("td", {
                                                                  staticClass:
                                                                    "jobs_detail_table_cell word-break",
                                                                  style: {
                                                                    borderTop:
                                                                      "1px solid" +
                                                                      _vm.colors
                                                                        .borderColor,
                                                                    borderRight:
                                                                      "1px solid" +
                                                                      _vm.colors
                                                                        .borderColor,
                                                                    borderBottom:
                                                                      "1px solid" +
                                                                      _vm.colors
                                                                        .borderColor
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      )
                                                    ],
                                                    2
                                                  )
                                                ]
                                              )
                                            ]
                                          : _vm._e()
                                      ]
                                    })
                                  ],
                                  2
                                ),
                                _c("div", { staticClass: "jobs_result_btn" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "jobs_btn_primary",
                                      style: {
                                        color: _vm.colors.mainButtonText,
                                        backgroundColor: _vm.colors.mainButton
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.step = 3
                                          _vm.scrollToTopOfModal()
                                        }
                                      }
                                    },
                                    [
                                      _vm.button.listBtn === ""
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(
                                                  _vm.searchJobLabelsProperty
                                                    .VIEW_DETAIL_JOB
                                                ) +
                                                "\n                      "
                                            )
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(_vm.button.listBtn) +
                                                "\n                      "
                                            )
                                          ])
                                    ]
                                  )
                                ])
                              ])
                            ]
                          )
                        }),
                        0
                      ),
                      _c("div", { staticClass: "jobs_btn_box" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "jobs_btn_secondary jobs_btn_medium jobs_btn_disabled"
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.searchJobLabelsProperty.BUTTON_BACK_PAGE
                                ) +
                                "\n              "
                            )
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "jobs_btn_secondary jobs_btn_medium",
                            style: {
                              color: _vm.colors.subButtonText,
                              backgroundColor: _vm.colors.subButton
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.searchJobLabelsProperty.BUTTON_NEXT_PAGE
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      ])
                    ]
                  : _vm._e(),
                _vm.step === 3
                  ? [
                      _c(
                        "div",
                        {
                          style: { backgroundColor: _vm.colors.pageBackground }
                        },
                        [
                          _c(
                            "h1",
                            {
                              staticClass:
                                "jobs_page_title jobs_page_title_customize",
                              style: { color: _vm.colors.pageText }
                            },
                            [
                              _vm._l(
                                _vm.headingSettings.filter(function(
                                  headingSetting
                                ) {
                                  return !headingSetting.itemResourceDeleted
                                }),
                                function(headingSetting, index) {
                                  return [
                                    _c("span", { key: "h" + index }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(headingSetting.display_name) +
                                          " "
                                      ),
                                      index <
                                      _vm.headingSettings.filter(function(
                                        headingSetting
                                      ) {
                                        return !headingSetting.itemResourceDeleted
                                      }).length -
                                        1
                                        ? _c("span", [_vm._v("/")])
                                        : _vm._e()
                                    ])
                                  ]
                                }
                              )
                            ],
                            2
                          ),
                          _vm._l(_vm.bodySettings, function(
                            bodySetting,
                            index
                          ) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "jobs_detail_text",
                                style: { color: _vm.colors.pageText }
                              },
                              [
                                _c("span", { key: "b" + index }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(bodySetting.display_name) +
                                      "\n                "
                                  )
                                ])
                              ]
                            )
                          }),
                          _vm._l(_vm.categoriesJobDetail, function(
                            category,
                            cIndex
                          ) {
                            return [
                              category &&
                              !category.categoryDeleted &&
                              !_vm.isEmptyCategory(
                                _vm.categoriesJobDetail,
                                cIndex
                              )
                                ? [
                                    _c(
                                      "h2",
                                      {
                                        key: "cd" + cIndex,
                                        staticClass: "jobs_category_title",
                                        style: {
                                          color: _vm.colors.pageText,
                                          borderLeftColor: _vm.colors.keyColor
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(category.categoryName) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        key: "tb" + cIndex,
                                        staticClass: "jobs_table_wrapper"
                                      },
                                      [
                                        _c(
                                          "table",
                                          { staticClass: "jobs_detail_table" },
                                          [
                                            _c(
                                              "tbody",
                                              {
                                                staticClass:
                                                  "jobs_detail_table_body"
                                              },
                                              [
                                                _vm._l(category.item, function(
                                                  item,
                                                  index
                                                ) {
                                                  return [
                                                    _c(
                                                      "tr",
                                                      {
                                                        key:
                                                          item.resourceField[0]
                                                            .name,
                                                        staticClass:
                                                          "jobs_detail_table_rows"
                                                      },
                                                      [
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "jobs_detail_table_head",
                                                            style: [
                                                              {
                                                                backgroundColor:
                                                                  _vm.colors
                                                                    .subColor
                                                              },
                                                              index === 0
                                                                ? {
                                                                    border:
                                                                      "1px solid" +
                                                                      _vm.colors
                                                                        .borderColor
                                                                  }
                                                                : {
                                                                    borderLeft:
                                                                      "1px solid" +
                                                                      _vm.colors
                                                                        .borderColor,
                                                                    borderRight:
                                                                      "1px solid" +
                                                                      _vm.colors
                                                                        .borderColor,
                                                                    borderBottom:
                                                                      "1px solid" +
                                                                      _vm.colors
                                                                        .borderColor
                                                                  }
                                                            ]
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "setting_word_break",
                                                                style: {
                                                                  color:
                                                                    _vm.colors
                                                                      .pageText
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                              " +
                                                                    _vm._s(
                                                                      item.itemName
                                                                    ) +
                                                                    "\n                            "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _c("td", {
                                                          staticClass:
                                                            "jobs_detail_table_cell word-break",
                                                          style: {
                                                            borderTop:
                                                              "1px solid" +
                                                              _vm.colors
                                                                .borderColor,
                                                            borderRight:
                                                              "1px solid" +
                                                              _vm.colors
                                                                .borderColor,
                                                            borderBottom:
                                                              "1px solid" +
                                                              _vm.colors
                                                                .borderColor
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                })
                                              ],
                                              2
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                : _vm._e()
                            ]
                          }),
                          _vm.commonSetting
                            ? _c("div", { staticClass: "jobs_btn_box" }, [
                                _vm.commonSetting.jobInquiryUrl
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "jobs_btn_primary",
                                        style: {
                                          color: _vm.colors.mainButtonText,
                                          backgroundColor:
                                            _vm.colors.mainButton,
                                          border:
                                            "1px solid" + _vm.colors.borderColor
                                        }
                                      },
                                      [
                                        _vm.button.contactBtn === ""
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.searchJobLabelsProperty
                                                      .BUTTON_CONTACT
                                                  ) +
                                                  "\n                "
                                              )
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.button.contactBtn
                                                  ) +
                                                  "\n                "
                                              )
                                            ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.commonSetting.entryPublic
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "jobs_btn_primary",
                                        style: {
                                          color: _vm.colors.mainButtonText,
                                          backgroundColor:
                                            _vm.colors.mainButton,
                                          border:
                                            "1px solid" + _vm.colors.borderColor
                                        }
                                      },
                                      [
                                        _vm.button.detailBtn === ""
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.searchJobLabelsProperty
                                                      .BUTTON_APPLY_JOB
                                                  ) +
                                                  "\n                "
                                              )
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(_vm.button.detailBtn) +
                                                  "\n                "
                                              )
                                            ])
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e(),
                          _c("div", { staticClass: "jobs_detail_back" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "jobs_btn_secondary jobs_btn_medium",
                                style: {
                                  color: _vm.colors.subButtonText,
                                  backgroundColor: _vm.colors.subButton,
                                  border: "1px solid" + _vm.colors.borderColor
                                },
                                on: {
                                  click: function($event) {
                                    _vm.step = 2
                                    _vm.scrollToTopOfModal()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.searchJobLabelsProperty
                                        .RETURN_JOB_SEARCH_TOP
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          ])
                        ],
                        2
                      )
                    ]
                  : _vm._e()
              ],
              2
            )
          ]
        )
      ]),
      _c("div", { staticClass: "setting_customize_footer" }, [
        _c("div", { staticClass: "setting_customize_footer_button" }, [
          _c(
            "button",
            {
              staticClass: "setting_btn_outline setting_btn_small",
              on: {
                click: function($event) {
                  _vm.$emit("close")
                  _vm.step = 1
                }
              }
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.labelProperties.BUTTON_CLOSE_MODAL) +
                  "\n        "
              )
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }